import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '../hooks/use-media-query';
import { MainActions } from '../components/main-actions';
import s from './layout.module.scss';
export const Layout = ({ isTg }) => {
    const isMobile = useMediaQuery(768);
    return (_jsx("main", { className: `${s.main} ${isMobile ? 'container-mobile' : 'container-pc'}`, children: _jsxs("div", { className: `${s.content}`, children: [_jsx(Outlet, {}), _jsx("div", { className: s.actions, children: _jsx(MainActions, { isTg: isTg }) })] }) }));
};
